import { paths } from "./rolecountry.types";
import { mockableGetRequest } from "./mockable-api-request";
import { realGetCountryAndRoleList } from "./api/rolecountry";
import { mockGetCountryAndRoleList } from "./mock/rolecountry";

export const getCountryAndRoleList = mockableGetRequest<
  paths["/exp/v1/dna/welcomeScreen/getCountryAndRoleList"]
>(realGetCountryAndRoleList, mockGetCountryAndRoleList);
